import React, { useState } from 'react';
import {
	Grid,
	TextField,
	Box,
	makeStyles,
	FormControlLabel,
	Radio,
	RadioGroup,
	FormControl,
	Popper,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import flt from '../assets/images/flt.png';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import DateRangeNew from '../components/reusableComponents/DateRangeNew';
import BodyText from '../components/reusableComponents/BodyText';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import {
	SearchReturnFormDispatch,
	SearchFormDispatch,
	SearchEtravFormDispatch,
	SearchTripjackFormDispatch,
} from '../reducers/HomeReducer';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import OneWayDestopDate from '../components/reusableComponents/OneWayDestopDate';
import { useLocation } from 'react-router-dom';
import {
	fetchCityDispatch,
	AddSearchFlightDispatch,
	SearchReturnEtravFormDispatch
} from '../reducers/HomeReducer';
import { setSelectedDepart, setSelectedOrigin } from '../reducers/UiReducer';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiFormControl-root': {
			'& div': {
				'& div': {
					display: 'none',
				},
			},
		},
		'& .MuiInput-underline:before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},
		'& input': {
			fontSize: 14,
			fontWeight: 600,
		},
		'& .MuiInput-underline:hover:not(.Mui-disabled):before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},

		'& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-184whfw-MuiAutocomplete-root .MuiAutocomplete-inputRoot':
			{
				paddingRight: 0,
			},
		// '& div': {
		// 	'& div': {
		// 		'& div': {
		// 			paddingRight: 0,
		// 		},
		// 	},
		// },
	},
	radio: {
		'& .MuiRadio-root': {
			color: 'white',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'white',
			fontSize: '18px',
			fontWeight: 800,
		},
	},
	radio2: {
		'& .MuiRadio-root': {
			color: 'black',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'black',
			fontSize: '14px',
			// fontWeight: 800,
		},
	},
}));
const OneWayFlightForm = () => {
	const [result, setResult] = useState([]);
	const [result2, setResult2] = useState([]);
	const classes = useStyles();
	const { city,agentlogin } = useSelector((state) => state.home);
	const handleRadio = (event) => {
		setValue(event.target.value);
	};
	const { originp, departp } = useParams();
	const history = useHistory();
	const dispatch = useDispatch();
	const location = useLocation();
	const theme = useTheme()
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const [value, setValue] = useState('Economy');
	const [leaving, setLeaving] = useState('DEL');
	const [trip, setTrip] = useState('oneway');
	const [going, setGoing] = useState('CCU');
	const [from, setFrom] = useState(null);
	const [to, setTo] = useState(null);
	const { origin, depart, selectedOrigin, selectedDepart,OriginO } = useSelector(
		(state) => state.ui
	);
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const { dataO, setData } = useState(originp);
	const { dataD, setData2 } = useState(departp);
	// let invoiceOptions = [];
	// let demo = [];
	// city &&
	// 	city.data &&
	// 	city.data.length > 0 &&
	// 	city.data.forEach((invoice, index) => {
	// 		invoiceOptions.push({
	// 			code: invoice.iata_code,
	// 			city: invoice.city,
	// 			country: invoice.country_name,
	// 		});
	// 		if (index < 50) {
	// 			demo.push({
	// 				code: invoice.iata_code,
	// 				city: invoice.city,
	// 				country: invoice.country_name,
	// 			});
	// 		}
	// 	});
	console.log('Location', location);
	const handleSubmit = (data) => {
		console.log(data);
		let org = data.Origin;
		let des = data.Destination;
		console.log(
			'vAL',
			data.Destination
				? data.Destination
				: location.state.body.Segments[0].Destination
		);
		let formData = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 1,
			PreferredAirlines: null,
			Segments: [
			  {
				Origin: data.Origin,
				Destination: data.Destination,
				FlightCabinClass: 1,
				PreferredDepartureTime: origin,
				// PreferredArrivalTime: '2022-03-18',
			  },
			  // {
			  // 	Origin: 'CCU',
			  // 	Destination: 'DEL',
			  // 	FlightCabinClass: 1,
			  // 	PreferredDepartureTime: '2022-03-18',
			  // 	// PreferredArrivalTime: '2022-03-18',
			  // },
			],
			Sources: "WEB",
			agent_id: agentlogin
			  ? agentlogin.status === 200
				? agentlogin?.result.result.id
				: 0
			  : 0,
			// agent_id: agentlogin&&agentlogin.status===200 ? agentlogin && agentlogin.result.result.id : 0,
		  };
		let formData2 = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 2,
			PreferredAirlines: null,
			Segments: [
			  {
				Origin: data.Origin,
				Destination: data.Destination,
				FlightCabinClass: 1,
				PreferredDepartureTime: origin,
				// PreferredArrivalTime: '2022-03-18',
			  },
			  {
				Origin: data.Destination,
				Destination: data.Origin,
				FlightCabinClass: 1,
				PreferredDepartureTime: depart,
				// PreferredArrivalTime: '2022-03-18',
			  },
			],
			Sources: "WEB",
			agent_id: agentlogin
			  ? agentlogin.status === 200
				? agentlogin?.result.result.id
				: 0
			  : 0,
		  };
		if (trip === 'oneway') {
			dispatch(SearchFormDispatch(formData, history, org, des, origin));
			dispatch(SearchEtravFormDispatch(formData, history, org, des, origin));
			dispatch(AddSearchFlightDispatch(formData));
			history.push({
				// pathname: '/oneway',
				state: {
					body: formData,
					OriginO: OriginO,
				},
			});
		} else {
			dispatch(
			  SearchReturnFormDispatch(
				formData2,
				history,
				selectedOrigin,
				selectedDepart
			  )
			);
			dispatch(
			  SearchReturnEtravFormDispatch(
				formData2,
				history,
				selectedOrigin,
				selectedDepart
			  )
			);
			dispatch(AddSearchFlightDispatch(formData));
			// console.log(formData2);
		  }
	};
	// console.log(invoiceOptions);
	const handleSearchOrigin = (event) => {
		let value = event.target.value.toLowerCase();
		console.log(value);
		let cityData = {
			keywords: value,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData, setResult));
	};
	const PopperMy = function (props) {
		return (
			<Popper
				{...props}
				style={styles.popper}
				className={classes.popper}
				placement='bottom-start'
			/>
		);
	};

	const styles = (theme) => ({
		popper: {
			width: 'fit-content',
		},
	});
	// const handleSearch2 = (event) => {
	// 	let value = event.target.value.toLowerCase();
	// 	let results = [];
	// 	console.log(value);
	// 	if (value.length >= 2) {
	// 		results =
	// 			invoiceOptions &&
	// 			invoiceOptions.filter((data) => {
	// 				return Object.values(data).join('').toLowerCase().includes(value);
	// 			});
	// 		setResult2(results);
	// 	} else {
	// 		setResult2([]);
	// 	}
	// };
	// console.log(leaving);
	// console.log(going);
	const handleChange2 = (e) => {
		console.log(e.target.value);
		dispatch(setTrip(e.target.value));
	};

	return (
		<>
			<Formik
				initialValues={{
					Origin: selectedOrigin.airport_code,
					Destination: selectedDepart.airport_code,
				}}
				validate={(values) => {
					const errors = {};
				}}
				onSubmit={handleSubmit}>
				{({ submitForm, isSubmitting, setFieldValue, values }) => (
					<>
						<Form style={{marginTop:matches?20:''}}>
							<Box className={classes.radio}>
								<FormControl onChange={handleChange2}>
									<RadioGroup
										row
										aria-labelledby='demo-row-radio-buttons-group-label'
										name='row-radio-buttons-group'>
										<FormControlLabel
											value='oneway'
											control={
												<Radio checked={trip == 'oneway' ? true : false} />
											}
											label='ONE WAY'
										/>
										<FormControlLabel
											value='roundtrip'
											control={
												<Radio checked={trip == 'roundtrip' ? true : false} />
											}
											label='ROUND TRIP'
										/>
									</RadioGroup>
								</FormControl>
							</Box>
							<Grid
								container
								spacing={2}
								alignItems='center'
								>
								<Grid item xs={12} md={12} lg={trip == 'roundtrip' ? 4 : 5}>
									<Grid container alignItems='center' spacing={2}>
										<Grid
											item
											xs={12}
											lg={6}
											style={{ display: 'flex', alignItems: 'center',marginTop:matches?10:'' }}>
											<div className={classes.root} style={{ width: '100%' }}>
												<span style={{ color: 'white' }}>Leaving From</span>
												<Autocomplete
													id='country-select-demo'
													sx={{
														background: 'white',
														borderRadius: '4px',
														padding: '10px',
														transition: 'none',
													}}
													value={selectedOrigin}
													// defaultValue={{
													// 	code: originp,
													// 	city: 'dfedf',
													// 	country: 'edfe',
													// }}
													clearOnBlur={true}
													PopperComponent={PopperMy}
													options={
														city && city.result.length > 0 ? city.result : []
													}
													filterOptions={(options, state) => options}
													autoHighlight
													getOptionLabel={(option) =>
														`${option.airport_name} (${option.airport_code}) `
													}
													renderOption={(props, option) => (
														<Box
															// mr={'5px'}
															component='li'
															sx={{ '& > img': { mr: 2 } }}
															{...props}>
															<img loading='lazy' width='20' src={flt} alt='' />
															<p style={{ fontSize: 13 }}>
																{option.city_name} ({option.airport_code}){' '}
																{option.airport_name}
															</p>
														</Box>
													)}
													onChange={(event, value) => {
														setFieldValue('Origin', value.airport_code);
														console.log(value.airport_code);
														dispatch(setSelectedOrigin(value));
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															onChange={handleSearchOrigin}
															name='origin'
														/>
													)}
												/>
											</div>
											{/* <SwapHorizontalCircleIcon
												onClick={() => {
													setTo(from);
													dispatch(setSelectedOrigin(to));
													dispatch(setSelectedDepart(from));
													setFrom(to);
												}}
												style={{
													color: 'white',
													width: '2em',
													height: '2em',
													marginTop: 20,
													cursor: 'pointer',
												}}
											/> */}
										</Grid>
										<Grid item xs={12}
											lg={6}>
											<div className={classes.root}>
												<span style={{ color: 'white' }}>Going To</span>
												<Autocomplete
													id='country-select-demo'
													sx={{
														background: 'white',
														borderRadius: 2,
														padding: '10px',
													}}
													options={
														city && city.result.length > 0 ? city.result : []
													}
													PopperComponent={PopperMy}
													value={selectedDepart}
													autoSelect={true}
													// defaultValue={{
													// 	code: departp,
													// 	city: 'dfedf',
													// 	country: 'edfe',
													// }}
													clearOnBlur={true}
													filterOptions={(options, state) => options}
													autoHighlight
													getOptionLabel={(option) =>
														`${option.airport_name} (${option.airport_code}) `
													}
													renderOption={(props, option) => (
														<Box
															// mr={'5px'}
															component='li'
															sx={{ '& > img': { mr: 2 } }}
															{...props}>
															<img loading='lazy' width='20' src={flt} alt='' />
															<p style={{ fontSize: 13 }}>
																{option.city_name} ({option.airport_code}){' '}
																{option.airport_name}
															</p>
														</Box>
													)}
													onChange={(event, value) => {
														setFieldValue('Destination', value.airport_code);
														console.log(value.airport_code);
														dispatch(setSelectedDepart(value));
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															onChange={handleSearchOrigin}
														/>
													)}
												/>
											</div>
										</Grid>
									</Grid>
								</Grid>
								<Grid
									item
									xs={12}
									md={12}
									lg={trip == 'oneway' ? 2 : trip == 'roundtrip' ? 4 : 2}>
									<Box display='flex' justifyContent='space-between'>
										<span style={{ color: 'white' }}>Depart Date</span>
										{trip == 'oneway' ? (
											''
										) : trip == 'roundtrip' ? (
											<span style={{ color: 'white' }}>Return Date</span>
										) : (
											''
										)}
									</Box>
									{trip == 'oneway' ? (
										<OneWayDestopDate />
										// <></>
									) : trip == 'roundtrip' ? (
										<DateRangeNew />
									) : (
										<OneWayDestopDate />
									)}
								</Grid>
								<Grid item xs={12} md={6} lg={trip == 'oneway' ? 3 : 2}>
									<ul class='menu' style={{ marginTop: 20, borderRadius: 2 }}>
										<li>
											<a
												style={{
													padding: 12,
													fontSize: 16,
													borderRadius: 4,
													overflow: 'hidden',
													whiteSpace: 'nowrap',
													textOverflow: 'ellipsis',
													fontWeight: 600,
												}}>
												{`${location.state.body?location.state.body.AdultCount:location.state.returnBody?location.state.returnBody.AdultCount:''} | ${location.state.body?location.state.body.ChildCount:location.state.returnBody?location.state.returnBody.ChildCount:''} | ${location.state.body?location.state.body.InfantCount:location.state.returnBody?location.state.returnBody.InfantCount:''} Travellers, ECONOMY`}
											</a>

											<ul style={{ padding: 5 }}>
												<li>
													<Box
														style={{ padding: 5 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText
															four
															textStyle={{
																color: 'black',
																fontSize: 18,
																fontWeight: 500,
															}}>
															Adult
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}
																onClick={() =>
																	adult === 0 ? '' : setAdult(adult - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 18,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}>
																<BodyText
																	textStyle={{ fontSize: 17, color: 'white' }}>
																	{adult}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}
																onClick={() =>
																	adult + child + infant === 9
																		? adult
																		: setAdult(adult + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 17,
																		color: 'white',
																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 5 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText
															four
															textStyle={{
																color: 'black',
																fontSize: 18,
																fontWeight: 500,
															}}>
															Child
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}
																onClick={() =>
																	child === 0 ? '' : setChild(child - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 18,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}>
																<BodyText
																	textStyle={{ fontSize: 17, color: 'white' }}>
																	{child}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}
																onClick={() =>
																	adult + child + infant === 9
																		? child
																		: setChild(child + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 17,
																		color: 'white',
																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 5 }}
														display='flex'
														justifyContent='space-between'
														textAlign='center'
														alignItems='center'>
														<BodyText
															four
															textStyle={{
																color: 'black',
																fontSize: 18,
																fontWeight: 500,
															}}>
															Infant
														</BodyText>
														<Box display='flex' alignItems='center'>
															<Box
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}
																onClick={() =>
																	infant === 0 ? '' : setInfant(infant - 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 18,
																		color: 'white',
																	}}>
																	-
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}>
																<BodyText
																	textStyle={{ fontSize: 17, color: 'white' }}>
																	{infant}
																</BodyText>
															</Box>
															<Box
																ml={'15px'}
																style={{
																	cursor: 'pointer',
																	background: 'rgb(239, 51, 57)',
																	padding: '0px 10px',
																	borderRadius: '5px',
																}}
																onClick={() =>
																	adult + child + infant === 9
																		? infant
																		: setInfant(infant + 1)
																}>
																<BodyText
																	textStyle={{
																		fontSize: 17,
																		color: 'white',
																	}}>
																	+
																</BodyText>
															</Box>
														</Box>
													</Box>
												</li>
												<li>
													<Box
														style={{ padding: 10 }}
														display='flex'
														justifyContent='space-between'>
														<Box className={classes.radio2}>
															<FormControl component='fieldset'>
																<RadioGroup
																	aria-label='gender'
																	name='gender1'
																	value={value}
																	color='black'
																	onChange={handleRadio}>
																	<FormControlLabel
																		value='Economy'
																		control={<Radio />}
																		label='Economy'
																	/>
																	<FormControlLabel
																		value='Business'
																		control={<Radio />}
																		label='Business'
																	/>
																	<FormControlLabel
																		value='First Class'
																		control={<Radio />}
																		label='First Class'
																	/>
																	<FormControlLabel
																		value='Premium Economy'
																		control={<Radio />}
																		label='Premium Economy'
																	/>
																</RadioGroup>
															</FormControl>
														</Box>
													</Box>
												</li>
											</ul>
										</li>
									</ul>
								</Grid>
								<Grid item xs={12} md={6} lg={2} style={{ marginTop: 12 }}>
									<input
										type='submit'
										value='Search'
										className='btn'
										style={{ width: '100%', fontSize: 24, borderRadius: 5 }}
									/>
								</Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default OneWayFlightForm;
